export default "__VITE_ASSET__BoGCKqvY__"